import {
    ClientAccount,
    CreateClientAccountRequest,
    CreateMultiLegShippingEstimateByFuelResponse,
    LuneClient,
    MultiLegShippingEmissionEstimate,
    UploadLogoResponse,
} from '@lune-climate/lune'
import { wrapAxiosPromise } from '@lune-fe/lune-components-lib'
import { AxiosError } from 'axios'
import { AsyncResult } from 'ts-results-es'

import { bootstrapAxiosClient, bootstrapAxiosClientNoInterceptors } from 'endpoints/util'

const buildClient = () =>
    new LuneClient(localStorage.getItem('token')!, `${process.env.REACT_APP_API_URL}`)

/**
 * Use `useClient()` instead of directly importing this value.
 */
export let luneClientDoNotUseThisDirectly = buildClient()

// Whenever the session token is update, refresh the client
export const bootstrapApi = () => {
    luneClientDoNotUseThisDirectly = buildClient()
}

// Special endpoints used to load emission estimate results for Pdf downloadable views
export const getEstimates = async (
    id: string,
    token: string,
): Promise<MultiLegShippingEmissionEstimate> => {
    const customApi = bootstrapAxiosClient(`${process.env.REACT_APP_API_URL}`, token)
    return (await customApi.get(`v1/estimates/shipping/multi-leg/${id}`)).data
}

export const getEstimatesByFuel = async (
    id: string,
    token: string,
): Promise<CreateMultiLegShippingEstimateByFuelResponse> => {
    const customApi = bootstrapAxiosClient(`${process.env.REACT_APP_API_URL}`, token)
    return (await customApi.get(`v1/estimates/shipping/multi-leg/by-fuel/${id}`)).data
}

export const createClientAccount = (
    request: CreateClientAccountRequest,
): AsyncResult<ClientAccount, AxiosError> => {
    const customApi = bootstrapAxiosClient(`${process.env.REACT_APP_API_URL}`)
    return wrapAxiosPromise(customApi.post(`v1/accounts/client`, request).then((res) => res.data))
}

export const uploadClientAccountLogo = (
    id: string,
    fd: FormData,
): AsyncResult<
    {
        data: {
            url: string
        }
    },
    AxiosError
> => {
    const customApi = bootstrapAxiosClientNoInterceptors(`${process.env.REACT_APP_API_URL}`)
    return wrapAxiosPromise(
        customApi
            .post(`/v1/accounts/client/${id}/logo`, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((res) => res.data),
    )
}

export const removeClientAccountLogo = (
    id: string,
): AsyncResult<UploadLogoResponse, AxiosError> => {
    const customApi = bootstrapAxiosClientNoInterceptors(`${process.env.REACT_APP_API_URL}`)
    return wrapAxiosPromise(
        customApi.delete(`/v1/accounts/client/${id}/logo`).then((res) => res.data),
    )
}

export const uploadAccountLogo = (
    id: string,
    fd: FormData,
): AsyncResult<
    {
        data: {
            url: string
        }
    },
    AxiosError
> => {
    const customApi = bootstrapAxiosClientNoInterceptors(`${process.env.REACT_APP_API_URL}`)
    return wrapAxiosPromise(
        customApi
            .post(`/v1/accounts/${id}/logo`, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((res) => res.data),
    )
}

export const removeAccountLogo = (id: string): AsyncResult<UploadLogoResponse, AxiosError> => {
    const customApi = bootstrapAxiosClientNoInterceptors(`${process.env.REACT_APP_API_URL}`)
    return wrapAxiosPromise(customApi.delete(`/v1/accounts/${id}/logo`).then((res) => res.data))
}
